<template>
  <div class="articles">
    <h1 class="title">{{category.title}}</h1>
    <div>
      <ul class="list pa0 ma0">
        <li class="mb3" v-for="article in paginatedOrders" :key="article.name">
          <button
            class="article-button"
            v-on:click="handleArticleClick(article.id)"
            :class="{
              'article-button--active': openArticleIds.includes(article.id)
            }"
          >
            <a
              style="color: inherit; text-decoration: inherit;"
              v-bind:href="`#${article.source_id}-${article.title.replace(/ /g, '-')}`"
            >{{ article.title }}</a>
          </button>
          <div class="article-body" v-show="openArticleIds.includes(article.id)">
            <div v-html="article.body"></div>
          </div>
        </li>
      </ul>
      <div class="container">
        <button @click="loadMore" v-if="currentPage * maxPerPage < articles.length" class="button__show-more">
          Show more
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M3 4.5l2.6 2.6c.2.2.5.2.7 0L9 4.5"></path></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name
  },
  data() {
    return {
      openArticleIds: [],
      currentPage: 1,
      maxPerPage: 20,
    };
  },
  methods: {
    handleArticleClick(id) {
      if (this.openArticleIds.includes(id)) {
        let index = this.openArticleIds.indexOf(id);

        this.openArticleIds.splice(index, 1);
      } else {
        this.openArticleIds.push(id);
      }
    },
    loadMore() {
      this.currentPage += 1;
    }
  },
  computed: {
    pageTitle() {
      const pageTitle = this.name;
      return pageTitle;
    },
    category() {
      const name = this.$store.state.categories[this.$route.meta.categoryId];
      return name;
    },
    articles() {
      const articlesArray = this.$store.state.articles[this.$route.meta.categoryId] || [];
      return articlesArray;
    },
    paginatedOrders() {
      return this.articles.slice(0, this.currentPage * this.maxPerPage);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.articles {
  .title {
    margin-bottom: 0.2rem;
    font-size: 32px;
  }
}

.article-button {
  color: $theme-highlight;
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  text-align: left;
  font-weight: 600;
  cursor: pointer;
  transition: 0.1s linear color;
  padding: 0.2rem 0;
  width: 100%;

  a {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
  &:hover {
    color: #b4b4b4;
  }
  &--active {
    margin: 0;
  }
}
.article-body {
  // -webkit-transition: max-height 0.3s cubic-bezier(0, 1, 0, 1); /* For Safari 3.1 to 6.0 */
  transition: 1s;
  max-height: 0px;
  overflow: hidden;
  font-size: 14px;
  font-family: Roboto, Helvetica, Arial, sans-serif;

  a {
    color: $theme-highlight;
    text-decoration: none;
  }
}
.container {
  display: flex;
}
.button__show-more {
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: #3bb4ef;
    flex: 1 1 auto;
    text-align: center;
    margin: 0;
    padding: 0;

    &:hover {
      background-color: transparent;
      color: #3bb4ef;
      text-decoration: underline;
    }

  svg {
    display: inline-block;
    margin-left: 1px;
    vertical-align: middle;
  }
}
</style>
